/**
 * Detect if the current page is on the investor site
 * Works in both development (checks path) and production (checks domain)
 */
export const isInvestorSite = (): boolean => {
  if (typeof window === 'undefined') return false;

  // Production: Check if hostname matches investor domain
  const investorDomain = process.env.NEXT_PUBLIC_INVESTOR_DOMAIN;
  if (investorDomain) {
    const investorHostname = investorDomain.replace(/^https?:\/\/(www\.)?/, '');
    if (window.location.hostname.includes(investorHostname.replace(/^https?:\/\//, ''))) {
      return true;
    }
  }

  // Development: Check if path includes /investor
  return window.location.pathname.includes('/investor');
};
